import PreloadState from "../../core/src/states/PreloadState";
import RealityCheckModel from "../../core/src/model/RealityCheckModel";
import App from "../../core/src/App";
import GameModel from "../../core/src/model/GameModel";
import Locale, { LocaleId } from "../../core/src/utils/Locale";
import GameLoader from "../../core/src/utils/GameLoader";
import ViewManager from "../../core/src/utils/ViewManager";
import { DefaultLayers } from "../../core/src/utils/Layers";
import PointerEvents from "../../core/src/const/PointerEvents";
import CommandManager from "../../core/src/commands/CommandManager";
import { Commands } from "../../core/src/commands/CommandEnum";
import ISBRealityCheckData from "../server/data/ISBRealityCheckData";
import InstanceFactory from "../../core/src/factories/InstanceFactory";
import PreloadView from "../../core/src/views/PreloadView";
import UIController from "../../core/src/ui/UIController";
import { VendorCommandsEnum } from "../commands/VendorCommandsEnum";
import FullscreenUtils from "../../core/src/utils/FullscreenUtils";
import VendorWrapper from "../controllers/VendorWrapper";
import { Loader } from "pixi.js";
import GameEvents from "../../core/src/const/GameEvents";
import { UIStates } from "../../core/src/ui/UIStates";
import CommManager from "../../core/src/controllers/CommManager";
import RequestRegister from "../../core/src/server/requests/RequestRegister";
import ErrorModel from "../../core/src/model/ErrorModel";
import VendorModel from "../model/VendorModel";
import BetModel from "../../core/src/model/BetModel";
import SpinModel from "../../core/src/model/SpinModel";
import ISavedSettings from "../../src/model/ISavedSettings";
import SoundController from "../../core/src/utils/SoundController";
import AutoplayModel from "../../core/src/model/AutoplayModel";
import * as currency_config from "../../../vendor_core/core/src/baseConfigs/currency-config.json";
import Configs from "../vendorConfigs/Configs";
import ControllerManager from "../../core/src/utils/ControllerManager";
import ClockController from "../../core/src/controllers/ClockController";
import ConsoleUtil from "../../core/src/utils/ConsoleUtil";
import ReelGroup from "../../core/src/views/ReelGroup";
import { UIButtons } from '../../core/src/ui/UIButtons';
import SwitchButton from '../../core/src/views/components/SwitchButton';
import UIUtils from "../../core/src/utils/UIUtils";
import Utils from "../../core/src/utils/Utils";
import { on, send } from "@rlx/feim";

export default class VendorPreloadState extends PreloadState {

    // True = log-in, then game load (needed for currencies to properly load)
    // False = game load, then log-in
    private loginFirstLogic: boolean = true;

    enter() {
        if (GameModel.gameConfig.hasJackpotsFeature) {
            setInterval(() => {
                CommandManager.execute(VendorCommandsEnum.UPDATE_JACKPOTS); //TODO lemmy think about setInterval

            }, 30000);
            CommandManager.execute(VendorCommandsEnum.UPDATE_JACKPOTS);
        };
        super.enter();
        if (this.loginFirstLogic) {
            this.sendGetConfigURL();
        }

        CommandManager.execute(VendorCommandsEnum.GAME_LOAD_STARTED);
    };

    startGame() {UIController.create();
        UIController.setState(UIStates.HIDDEN);
        // Update the bet bar
        CommandManager.execute(Commands.UPDATE_UI);

        // Update the info bar
        if(CommandManager.has(Commands.UPDATE_INFO_BAR)) {
          CommandManager.execute(Commands.UPDATE_INFO_BAR);
        }

        this.startMusicPlayback();
        App.dispatcher.emit(GameEvents.GAME_STARTED);
        VendorModel.allowSwipeSpin = false;
        ReelGroup.instance.disableSwipeSpin();
        App.assets.onResourcesLoaded();
        this.refreshTurboButton();
        this.exit();
    }

    protected refreshTurboButton(): void {
        let btn = ViewManager.getLayer(DefaultLayers.BetBar)
            .getCurrentScene()
            .buttons.get(UIButtons.Turbo) as SwitchButton;
        btn?.switch(GameModel.turboSpin);
    }

    public bootComplete(loader: Loader) {
        if (App.config.showFullscreenArrow != false) {
            FullscreenUtils.init(VendorWrapper.onResize);
        } else {
            // Fullscreen utils are disabled, so we need to hide the page overflow
            if(GameModel.isMobile(true)) {
                document.body.style.overflow = "auto";
            }
        }

        Locale.addSource(loader.resources.localization.data);
        this.preloadView = InstanceFactory.getClass("PreloadView") as PreloadView;
        // if (ViewManager.getDomLayer(DefaultLayers.Background)) {
        //     ViewManager.getDomLayer(DefaultLayers.Background).playDefault();
        // }

        GameLoader.loadAssets(
            GameLoader.config.mainResources,
            this.loadMusic.bind(this),
            this.preloadView.handleProgress.bind(this.preloadView)
        );
    }

    public preloadComplete() {
        CommandManager.execute(VendorCommandsEnum.GAME_LOAD_COMPLETED);
        App.assets.onResourcesLoaded();

        if (this.loginFirstLogic) {
            this.closePreloadScene();
        } else {
            this.sendGetConfigURL();
        }
    }

    private sendGetConfigURL() {
        CommManager.send(
            RequestRegister.get("getclientconfigURL"),
            (data) => {
                // console.log("[AuthState] Token response", data);
                this.onGetConfigURLReceived(data);
            },
            this,
            (err) => {

                // THIS CODE IS ONLY FOR DEV BUILDS !!! THIS CODE NEED US TO WORK GAME ON OUR SERVER (clients.atom.......)
                // ConsoleUtil.red("[GET CLIENT CONFIG URL]: FAIL TO GET CDNCONFIG.JSON FROM THE SERVER", err);
                this.onGetConfigURLReceived(null);

                // THIS ROW IS FOR RELEASE BUILD !!!!!!
                // this.onError(err);

            }
        );
    }

    private onGetConfigURLReceived(data) {
        Configs.vendorServer.parseParams(data);
        this.sendGetClientConfig();
    }

    private sendGetClientConfig() {
        CommManager.send(
            RequestRegister.get("getclientconfig"),
            (data) => {
                // console.log("[AuthState] Token response", data);
                this.onClientConfigReceived(data);
            },
            this,
            (err) => {
                this.onError(err);
            }
        );
    }

    protected onClientConfigReceived(data) {
        Configs.game.parseClientConfig(data);
        if(data?.minSpinTime != 0) {
            App.config.minSpinTime = data.minSpinTime / 1000;
        }

        // In case we have a turbo allowed, but the jurisdiction specify a minimal spin time,
        // we should still have a turbo, but we must respect the min spin time too.
        const adjustTurboTime = data?.quickStop && data?.minSpinTime;


        if (adjustTurboTime) {
            App.config.quickSpinTime = App.config.minSpinTime;
        }

        // Ensure we clear the game specific stuff.
        App.config.NO_SKIP_JURISDICTION = [];
        // Check whether to deny the spin skip feature.
        if (data?.disableSkipFeature || adjustTurboTime || data.minSpinTime) {
            // Deny the spin skip
            App.config.NO_SKIP_JURISDICTION = [GameModel.jurisdiction];
        }

        CommandManager.execute(
            VendorCommandsEnum.CONFIGURE,
            {
                clientconfigResponse: data
            }
        );

        this.loginUser();
        // this.initSoundLoading();
    }

    private loginUser(): void {
        if (
            !GameModel.urlParams.moneymode ||
            GameModel.urlParams.moneymode == "real"
        ) {
            this.sendTokenRequest();
        } else {
            this.sendFunMoneyLogin();
        }
    }

    protected sendTokenRequest() {
        CommManager.send(
            RequestRegister.get("tokenRequest"),
            (data) => {
                // console.log("[AuthState] Token response", data);
                this.onTokenReceived(data);
            },
            this,
            (err) => {
                this.onError(err);
            }
        );
    }

    protected onTokenReceived(data) {
        if(data.errorCode) {
            this.onError(data);
        } else {
            GameModel.update(data);
            this.sendLoginRequest();
        }
    }

    protected sendLoginRequest() {
        CommManager.send(
            RequestRegister.get("loginRequest"),
            (data) => {
                // Change the currency for testing here !!!
                // data.stats.currency = "PLN"

                // console.log("[AuthState] Login response", data);
                CommandManager.execute(
                    VendorCommandsEnum.CONFIGURE,
                    {
                        loginResponse: data
                    }
                );
                this.onLoginReceived(data);
            },
            this,
            (err) => {
                this.onError(err);
            }
        );
    }

    protected sendFunMoneyLogin() {
        CommManager.send(
            RequestRegister.get("funLoginRequest"),
            (data) => {
                ConsoleUtil.log("[AuthState] FUN money login", data);
                CommandManager.execute(
                    VendorCommandsEnum.CONFIGURE,
                    {
                        loginResponse: data
                    }
                );
                this.onLoginReceived(data);
            },
            this,
            (err) => {
                this.onError(err);
            }
        );
    }

    protected onLoginReceived(data) {
        // Settings first, then the model updates, otherwise the balance might be wrong.
        this.setSettings(data.savedSettings);

        Configs.buyFeature?.parseConfig(data);

        GameModel.update(data);
        VendorModel.update(data);
        BetModel.update(data);
        BetModel.setInitialParams();
        this.resolveCurrency(data);
        SpinModel.update(data);
       /// BBModel.update(data);
        SpinModel.generateReelsets(); // only going to be used until proper spinner is made because currently fake reels are needed for
        App.dispatcher.emit(GameEvents.REEL_SETS_INITIALIZED);
        const hasFreeSpinsRecovery = GameModel.restoreData && SpinModel.hasFreespins() && data?.refresh?.roundType === "normal";
        const hasJackpotRecovery = data?.refresh?.tease == true;
        if (data.refresh.win && data.refresh.restoreState) {
            BetModel.balance -= data.refresh.win;
        }

        if (data.savedSettings.bet && data.savedSettings.bet.currentBet != undefined
        ) {
            CommandManager.execute(
                Commands.SET_BET,
                {
                    coinIndex: data.savedSettings.bet.currentBet,
                    multiplier: undefined,
                    value: undefined
                }
            );
        }

        // Always clear the accumulated win for regular game - this is by requirements.
        if (!hasFreeSpinsRecovery && !hasJackpotRecovery) {
            SpinModel.accumulatedWin = 0;
        }

        // TODO check data that comes when there are freespins active

        // If reality check limits were passed - send them to the server
        const rcInterval = parseInt(GameModel.urlParams.rcinterval);
        let rcElapsed = parseInt(GameModel.urlParams.rcelapsed) || 0;
        if (rcInterval) {
            GameModel.hasRealityCheck = true;
            if(rcElapsed && rcInterval > rcElapsed) {
                rcElapsed *= 1000;
            }
            RealityCheckModel.sessionStartTime = Date.now() - rcElapsed;
            this.forceRealityCheckLimits();
        }

        CommandManager.execute(VendorCommandsEnum.BALANCE_UPDATE, BetModel.balance);
        CommandManager.execute(VendorCommandsEnum.WIN_UPDATE, SpinModel.accumulatedWin);
        if(!data.savedSettings) {
            CommandManager.execute(
                Commands.SET_BET,
                {
                    coinIndex: BetModel.coinSizeIndex,
                    multiplier: undefined,
                    value: undefined
                }

            );

            SoundController.toggleEffects(SoundController.isSoundEnabled);
            SoundController.toggleMusic(SoundController.isMusicEnabled);

        }

        // Update the reality check data
        this.configureRealityCheck(data);

        if (ErrorModel.hasError()) {
            this.exit();
        } else {
            if (!this.loginFirstLogic) {
                this.closePreloadScene();
            }
        }
    }

    private configureRealityCheck(data) {
        let realityCheckData: ISBRealityCheckData = data?.stats?.realityCheck;

        if (realityCheckData) {
            // Only setup Reality Check if there are any limits
            if (
                realityCheckData.lossLimit ||
                realityCheckData.sessionLimitSeconds
            ) {
                RealityCheckModel.update(realityCheckData);
                GameModel.hasRealityCheck = true;
            }
        }
    }

    private forceRealityCheckLimits() {
        CommManager.send(
            RequestRegister.get("setRealityCheckLimits"),
            (data) => {
                // console.log("[AuthState] Set RC Limits response", data);
                if (data.status == "ok") {
                    // Also force them in-game - if all is ok on the server
                    RealityCheckModel.update(<ISBRealityCheckData>{
                        sessionLimitSeconds: GameModel.urlParams.rcinterval,
                        sessionMinutes: parseInt(GameModel.urlParams.rcelapsed) / 60,
                    });
                }
            },
            this
        );
    }

    protected resolveCurrency(data) {
        if (data.stats && data.stats.currency) {
            BetModel.currency = {
                ISO: data.stats.currency,
                symbol: currency_config[data.stats.currency].symbol,
                decimals: currency_config[data.stats.currency].decimals,
            };
        }
    }

    public closePreloadScene() {

        const preloadLayer = ViewManager.getLayer(DefaultLayers.Preloader);
        const scene = preloadLayer.setScene("start");
        this.buildViews();


        ControllerManager.addController(
            "clockController",
            new ClockController()
        );

        ViewManager.getLayer(DefaultLayers.Header)
            .setScene().sceneTextFields.get("clock")
            .visible = !Configs.game.clientConfig.hideClock;

        if(VendorModel.allowSkipIntro) {
            this.initSoundLoading();
            preloadLayer.clear();
            UIController.addTurboListener();
            this.startGame();
        } else {
            scene.interactive = true;

            if(ErrorModel.hasError()){
                const is559 = ErrorModel.errorCode === 559;
                let text, error, title;
                const continueBtn = scene.buttons.get("continue");
                continueBtn.setEnabled(false);

                if(is559) {
                    title = ErrorModel.displayMessage
                    text = ErrorModel.errorMessage;
                } else {
                    error = 'error.' + ErrorModel.errorCode;
                    title = Locale.getString(LocaleId.gui_lbl_error);
                    text = Locale.getString(error);

                    if (!Locale.isTranslated(text, error)) {
                        text = !Utils.isNullOrWhiteSpace(ErrorModel.errorMessage) ? ErrorModel.errorMessage : text;
                    }
                }

                const erorrHandledByOperator = send.errorMessage(ErrorModel.rawError);

                if(erorrHandledByOperator) {
                    return;
                }

                UIUtils.showMessageBox(text, title);

            } else {
                scene.buttons.get("continue").on(PointerEvents.DOWN, () => {
                    this.initSoundLoading();
                    preloadLayer.clear();
                    UIController.addTurboListener();
                    this.startGame();
                });
            }
        }
    }

    private setSettings(savedSettings: ISavedSettings) {
        if (savedSettings) {
            // If there are Sound settings saved
            if (savedSettings.sound) {
                SoundController.toggleEffects(savedSettings.sound.effects);
                SoundController.toggleMusic(savedSettings.sound.music);
            }

            // If there are Bet settings saved
            if (
                savedSettings.bet &&
                savedSettings.bet.currentBet != undefined
            ) {
                CommandManager.execute(
                    Commands.SET_BET,
                    {
                        coinIndex: savedSettings.bet.currentBet,
                        multiplier: undefined,
                        value: undefined
                    }
                );
            }

            // If there are Autoplay settings saved
            if (savedSettings.autoplay) {
                AutoplayModel.initialAutospinNum = Number(savedSettings.autoplay.spins) || 0;
                AutoplayModel.initialWinLimit = Number(savedSettings.autoplay.winLimit) || 0;
                AutoplayModel.initialTotalWinLimit = Number(savedSettings.autoplay.totalWinLimit) || 0;
                AutoplayModel.initialLossLimit = Number(savedSettings.autoplay.lossLimit) || 0;
                AutoplayModel.initialStopOnAnyWin = savedSettings.autoplay.stopOnAnyWin || false;
            }

            // If there are SettingPage settings saved
            if (savedSettings.settingsPage) {
                GameModel.spaceToSpin = !GameModel.isMobile() && savedSettings.settingsPage.spaceToSpinTurnOn;
                VendorModel.allowSwipeSpin = savedSettings.settingsPage.swipeReelsTurnOn;
                VendorModel.allowSkipIntro = savedSettings.settingsPage.allowSkipIntroOn;
                GameModel._turboSpin = savedSettings.settingsPage.fastPlayOn;
                if (GameModel.turboSpin && Configs.game.clientConfig.quickStop == false) {
                    GameModel._turboSpin = false;
                }
            }

            if (savedSettings.balance) {
                BetModel.balance = savedSettings.balance.ba;
            }

            if (savedSettings.freegames?.expiredDuringFreeSpins) {
                VendorModel.hasFreeGamesExpiredDuringFreespins = true;
            }
        }
    }

    protected onError(error) {
        ConsoleUtil.log("[RelaxAuth] Error", error);
        ErrorModel.update(error);
        if (this.loginFirstLogic) {
            // We stay on this state. This was we have a chance to redirect to error state.
            // when the next line is executed.
            // throw new Error(error?.errorMessage || "Unknown error occured");
        } else {
            this.exit();
        }
    }
}
